const validateSelect = require('../common/validate-select');

const init = () => {
	window.jQuery('#aboutForm').on('submit', validate);
};

const validate = (e) => {
	let error = false;
	error = validateSelect('select.isRequired');
	return !error;
};

module.exports = {
	init
};
